import { useMemo, useState } from 'react'
import { Button, Form, Modal, Table } from 'react-bootstrap'
import useCheckedWorkers from './hooks';

const WorkersModal = ({
	isMobile,
	show,
	onHide,
	workers,
	categories,
	selectedCategory,
	onSelect,
	excludedCategoryId
}) => {
	const [selectedWorkers, setSelectedWorkers] = useState([])

	const filteredWorkers = selectedCategory
		? workers.filter(worker => worker.categoryId === selectedCategory)
		: workers;

	const filteredWorkersWithoutRemoved = useMemo(() => {
		return filteredWorkers.filter(w => w.categoryId !== excludedCategoryId)
			.map(worker => worker.id)
			.filter(f => selectedWorkers.includes(f));
	}, [selectedWorkers]);

	const filteredWorkersWithRemoved = useMemo(() => {
		return filteredWorkers
			.filter(worker => worker.categoryId !== excludedCategoryId)
	}, [filteredWorkers]);

	const checkAllWorkers = useCheckedWorkers(selectedWorkers, filteredWorkers);
	const checkWithoutRemoved = useCheckedWorkers(
		filteredWorkersWithoutRemoved, filteredWorkersWithRemoved);

	const selectedCategoryName = categories.find(
		category => category.id === selectedCategory
	)?.name

	const handleWorkerSelect = worker => {
		setSelectedWorkers(prevState => {
			if (prevState.includes(worker.id)) {
				return prevState.filter(id => id !== worker.id)
			} else {
				return [...prevState, worker.id]
			}
		})
	}

	const handleSelectAll = () => {
		setSelectedWorkers(checkAllWorkers ? [] : filteredWorkers.map(worker => worker.id))
	}


	const handleSelectAllExceptExcluded = () => {
		setSelectedWorkers(checkWithoutRemoved ? []
			: filteredWorkers.filter(w => w.categoryId !== excludedCategoryId)
				.map(worker => worker.id))
	}

	const handleModalClose = () => {
		onHide()
		onSelect(
			selectedWorkers.map(id => workers.find(worker => worker.id === id))
		)
	}

	return (
		<Modal
			show={show}
			onHide={onHide}
			size='lg'
			aria-labelledby='contained-modal-title-vcenter'
			centered
		>
			<Modal.Header closeButton>
				<Modal.Title id='contained-modal-title-vcenter'>
					{selectedCategoryName
						? `Работники категории "${selectedCategoryName}"`
						: 'Выбор работников'}
				</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<Form>
					<div className="mb-3">
						<Form.Check
							type='checkbox'
							label='Выбрать всех'
							checked={checkAllWorkers}
							onChange={handleSelectAll}
							className="mb-2"
						/>
						<Form.Check
							type='checkbox'
							label='Выбрать всех, кроме исключенных'
							checked={checkWithoutRemoved}
							onChange={handleSelectAllExceptExcluded}
						/>
					</div>
					<div style={{
						maxHeight: '400px',
						overflowY: 'auto',
						overflowX: 'hidden'
					}}>
						<Table striped bordered hover>
							<thead style={{ position: 'sticky', top: 0, background: 'white' }}>
								<tr>
									<th></th>
									<th>ФИО</th>
									{!isMobile ? <th>Телефон</th> : ''}
									<th>Категория</th>
								</tr>
							</thead>
							<tbody>
								{filteredWorkers.map(worker => {
									const categoryName = categories.find(
										category => category.id === worker.categoryId
									)?.name
									return (
										<tr key={worker.id}>
											<td>
												<Form.Check
													type='checkbox'
													checked={selectedWorkers.includes(worker.id)}
													onChange={() => handleWorkerSelect(worker)}
												/>
											</td>
											<td
												role='button'
												onClick={() => handleWorkerSelect(worker)}
											>{`${worker.secondName} ${worker.firstName}  ${worker.thirdName}`}</td>
											{!isMobile ? (
												<td
													role='button'
													onClick={() => handleWorkerSelect(worker)}
												>
													{worker.phone}
												</td>
											) : (
												''
											)}
											<td
												role='button'
												onClick={() => handleWorkerSelect(worker)}
											>
												{categoryName}
											</td>
										</tr>
									)
								})}
							</tbody>
						</Table>
					</div>
				</Form>
			</Modal.Body>
			<Modal.Footer>
				<Button variant='secondary' onClick={() => onHide()}>
					Закрыть
				</Button>
				<Button onClick={handleModalClose}>Выбрать</Button>
			</Modal.Footer>
		</Modal>
	)
}

export default WorkersModal